__turbopack_context__.v({
  "box": "CustomRadio-module__JooeFG__box",
  "disabled": "CustomRadio-module__JooeFG__disabled",
  "dot": "CustomRadio-module__JooeFG__dot",
  "input": "CustomRadio-module__JooeFG__input",
  "label": "CustomRadio-module__JooeFG__label",
});
